export default __webpack_public_path__ + "static/media/womenTrousers.47e30bed.svg";